exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-stepper .v-stepper__content[data-v-4ff59839]{padding-top:4px;padding-bottom:0px}", ""]);
